import AlanGoh from "../Assets/AlanGoh.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img className="card-img-style" src={AlanGoh} alt="judge picture"></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Alan Goh</h2>
        <p className="card-sub-name-style">
          Assistant Chief Executive, Platform Services, Synapxe
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Alan Goh</h2>
            <h3>Assistant Chief Executive, Platform Services, Synapxe</h3>

            <br />
            <p>
              Mr Alan Goh is the Assistant Chief Executive of Synapxe,
              Singapore’s HealthTech agency. He leads Platform Services which
              includes digital, analytics & AI, cloud, infrastructure and
              first-line cybersecurity capabilities. He is involved in Healthier
              SG (HSG), a national initiative by the Ministry of Health (MOH) to
              shift focus to preventive care, and also leads HealthHub, a
              national digital service that empowers citizens in personal health
              management.
              <br />
              <br />
              During the nation’s fight against COVID-19, Mr Goh has led
              multiple teams to rapidly deploy tech solutions for Covid
              response. This included technology enablement of COVID-19
              vaccination sites in different settings across Singapore, at speed
              and at scale, to enable safe and efficient vaccination of the
              population.
              <br />
              <br />
              With more than 20 years of experience in the IT industry, Mr Goh
              has diverse skillsets in digitalisation, security, analytics,
              large scale systems implementation and operations. He has
              established a strong track record in executing successful complex
              technology operations with high impact and driving digital
              transformation. Prior to Synapxe, Mr Goh was the Chief Information
              Officer for M1 for 8 years, driving digitalisation and agile
              development of tech capabilities in a rapidly changing and highly
              competitive telco industry. Mr Goh started his career in Accenture
              where he spent 14 years as a key consultant across multiple
              industries, with significant focus in Communications and Media.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
